import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img
            src="/logo.png"
            alt="Greenville Integrated Solutions"
            className="h-32 w-auto object-contain mb-5 -ml-3"
          />
          <p className="text-sm text-slate-600 max-w-md leading-relaxed">
            Low-voltage systems integrator specializing in network access control,
            audio-visual systems, IP surveillance, and certified structured cabling.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs font-mono uppercase tracking-[0.18em] text-slate-500 mb-4">
            Services
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="text-slate-700 hover:text-[#1E3A6B]">Network Access Control</Link></li>
            <li><Link to="/services" className="text-slate-700 hover:text-[#1E3A6B]">AV Systems</Link></li>
            <li><Link to="/services" className="text-slate-700 hover:text-[#1E3A6B]">Security Cameras</Link></li>
            <li><Link to="/services" className="text-slate-700 hover:text-[#1E3A6B]">Structured Cabling</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs font-mono uppercase tracking-[0.18em] text-slate-500 mb-4">
            Contact
          </h4>
          <ul className="space-y-3 text-sm text-slate-700">
            <li className="flex items-center gap-2"><Phone size={14} className="text-[#1E3A6B]" /> (619) 993-3329</li>
            <li className="flex items-center gap-2"><Mail size={14} className="text-[#1E3A6B]" /> mhasoneh@greenvilleis.com</li>
            <li className="flex items-center gap-2"><MapPin size={14} className="text-[#1E3A6B]" /> Greenville, SC · greenvilleis.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 text-xs text-slate-500 flex justify-between">
          <span>© {new Date().getFullYear()} Greenville Integrated Solutions. All rights reserved.</span>
          <Link to="/admin/login" className="hover:text-slate-700" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
